export const MotionSymbol = Symbol('Motion')
export const AnimationApiSymbol = Symbol('AnimationApi')
export const name = 'motion' as const
